import { useCallback } from 'react';
import { observer } from 'mobx-react';
import { useRouter } from 'next/router';

import { TextInput, Field, Form, Button } from 'modules/common/ui';

import { FormRoot, FormInput, FormButton } from '../Form';
import { schema, Fields } from './LoanForm.Schema';
import { Store } from '../../stores';

const FormComponent = () => {
  const store = Store.use();
  const router = useRouter();

  const submitLoan = useCallback(
    async (data: any) => {
      await store.submitLoanForm(data, () => {
        router.push('/pay/send');
      });
    },
    [store, router],
  );

  return (
    <FormRoot>
      <Form schema={schema} onSubmit={submitLoan}>
        <FormInput>
          <Field
            label="Номер займа *"
            htmlFor={Fields.LOAN_NUMBER}
            name={Fields.LOAN_NUMBER}
            error={store.errorMessage}
          >
            <TextInput
              name={Fields.LOAN_NUMBER}
              id={Fields.LOAN_NUMBER}
              inputMode="numeric"
              placeholder="707-*"
              mask="707-00000000000000000000"
              invalid={Boolean(store.errorMessage)}
            />
          </Field>
        </FormInput>
        <FormInput>
          <Field
            label="Дата рождения *"
            htmlFor={Fields.BIRTH_DATE}
            name={Fields.BIRTH_DATE}
          >
            <TextInput
              name={Fields.BIRTH_DATE}
              id={Fields.BIRTH_DATE}
              inputMode="numeric"
              mask="00.00.0000"
              placeholder="01.02.1970"
            />
          </Field>
        </FormInput>
        <FormButton>
          <Button variant="filled" type="submit">
            Перейти к оплате
          </Button>
        </FormButton>
      </Form>
    </FormRoot>
  );
};

export const LoanForm = observer(FormComponent);
